import type { GridColDef } from "@mui/x-data-grid-premium";
import type { DocDataGrid_ItemFragment } from "../DocDataGrid.generated.js";
import type { DocDataGridRow } from "../types.js";
import type { ProductColumns__ItemFragment } from "./productColumns.generated.js";
import { ProductSapConfigCell } from "../cells/ProductSapConfigCell.js";

interface Options {
  headerName: string;
  projectId: string;
  docId: string;
}

export function createProductSapConfigColumn<
  T extends DocDataGrid_ItemFragment & ProductColumns__ItemFragment,
>(options: Options): GridColDef<DocDataGridRow<T>> {
  return {
    field: "productSapConfig",
    headerName: options.headerName,
    width: 40,
    editable: false,
    sortable: false,
    filterable: false,
    resizable: false,
    renderCell: params => {
      if (params.row.kind === "input" || !params.row.item) return null;
      const item = params.row.item;
      if (item.type !== "paid" || item.isItemEliminated) return null;
      const articleNumber = item.product?.articleNumber;
      if (!articleNumber) return null;
      return (
        <ProductSapConfigCell
          projectId={options.projectId}
          docId={options.docId}
          itemId={item.id}
          articleNumber={articleNumber}
          manufacturerArticleNumber={item.product?.manufacturerArticleNumber}
          materialBuyingPrice={null}
        />
      );
    },
  };
}
